import { ConstData } from "./helpers";

export const STATES: ConstData[] = [
  { title: "Australian Capital Territory", value: "Australian Capital Territory" },
  { title: "New South Wales", value: "New South Wales" },
  { title: "Northern Territory", value: "Northern Territory" },
  { title: "Queensland", value: "Queensland" },
  { title: "South Australia", value: "South Australia" },
  { title: "Tasmania", value: "Tasmania" },
  { title: "Victoria", value: "Victoria" },
  { title: "Western Australia", value: "Western Australia" },
]



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/states.ts